import React from 'react';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/pro-light-svg-icons';

// import { faArrowRight } from '@fortawesome/pro-regular-svg-icons';
import Icon from '../../artzu-ui/src/Icon';

const NewCourseSection = ({
  icon,
  title,
  changePage,
  page,
  passed,
  disabled = false,
  color,
  clickDisabled
}) => (
  <div
    className="new-course__section"
    onClick={clickDisabled ? null : () => changePage(page, passed)}
    style={clickDisabled ? { color: '#DEDEDE' } : null}>
    {/* <div className="course-section_icon">
      <FontAwesomeIcon icon={icon} size="3x" />
    </div> */}
    <div className="new-course__section__icon">
      <FontAwesomeIcon
        className=""
        icon={faCheckCircle}
        size={'2x'}
        color={color ? '#128DFF' : null}
      />
    </div>

    {/* <span className="course-section_title">{title}</span> */}
    <div className="new-course__section__title">{title}</div>
    <div className="new-course__section__chevron">
      <Icon
        name="ChevronRight"
        size="xs"
        color={clickDisabled ? '#DEDEDE' : '#414141'}
      />
    </div>
    {/* <div className="course-section_start">`
      <button
        disabled={disabled}
        className={`course-section_button${disabled ? ' disabled' : ''}`}
        onClick={() => changePage(page, passed)}>
        START <FontAwesomeIcon icon={faArrowRight} fixedWidth size="sm" />
      </button>
    </div> */}
  </div>
);

export default NewCourseSection;



// WEBPACK FOOTER //
// ./src/components/NewCourse/NewCourseSection.js